'use client'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"
import { FaUser, FaStethoscope } from "react-icons/fa"
import { BaseSyntheticEvent, ChangeEvent, useState } from "react"
import baseApi from "@/utils/baseApiUrl"
import { toast } from "sonner"
import ContactPageForm from "../reusableComponents/contactPageForm"
interface ComponentProps {
  contactMail: string
}

export default function ContactForm({ contactMail }: ComponentProps) {
  const API = baseApi()
  const [formData, setFormData] = useState({
    userRole: "",
    name: "",
    surname: "",
    phone: "+90",
    email: "",
    message: ""
  })
  const [isLoading, setIsLoading] = useState<boolean>(false)

  function gatherFormData(key: string, e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setFormData((prev) => {
      if (key === "phone" && e.target.value === "+9") {
        return {
          ...prev
        }
      } else {
        return {
          ...prev,
          [key]: e.target.value
        }
      }
    })
  }

  async function submitForm(e: BaseSyntheticEvent) {
    e.preventDefault()
    try {
      setIsLoading(true)
      const [response, gmailResponse] = await Promise.all([
        fetch(`${API}/items/emailFolder`, {
          method: 'POST',
          body: JSON.stringify({ ...formData, source: "contactPage", contactMail }),
          headers: {
            'Content-Type': 'application/json'
          }
        }),
        fetch(`https://caressflow.com.tr${process.env.NEXT_PUBLIC_EMAIL_API}`, {
          method: 'POST',
          cache: 'no-cache',
          body: JSON.stringify({ ...formData, source: "contactPage", contactMail }),
          headers: {
            'Content-Type': 'application/json'
          }
        })
      ])

      if (!response.ok) {
        const customErrorMessage = await response.json()
        const error = new Error(customErrorMessage.message)
        throw error
      }

      setFormData({
        userRole: "",
        name: "",
        surname: "",
        phone: "+90",
        email: "",
        message: ""
      })
      setIsLoading(false)
      toast.success("Bilgiler Gönderildi!")
    } catch (err: unknown) {
      const error = err as Error
      setIsLoading(false)
      toast.error("Bilgiler Gönderilirken bir hata oluştu!")
    }
  }

  return (
    <form onSubmit={(e) => submitForm(e)} className="w-full max-w-lg space-y-6 bg-white py-7 px-5 text-pink-bg">

      <div>

        <Tabs defaultValue="patient">
          <TabsList className="grid w-full grid-cols-2 rounded-lg bg-gray-100 p-1">
            <TabsTrigger
              value="patient"
              onClick={() => setFormData((prev) => {
                const prevData = { ...prev }
                prevData['userRole'] = 'patient'
                return prevData
              })}
              className="flex items-center justify-center gap-2 rounded-md data-[state=active]:bg-pink-bg data-[state=active]:text-white data-[state=active]:shadow-sm transition-all"
            >
              <FaUser className="h-4 w-4" />
              Hasta
            </TabsTrigger>

            <TabsTrigger
              value="doctor"
              onClick={() => setFormData((prev) => {
                const prevData = { ...prev }
                prevData['userRole'] = 'doctor'
                return prevData
              })}
              className="flex items-center justify-center gap-2 rounded-md data-[state=active]:bg-pink-bg data-[state=active]:text-white data-[state=active]:shadow-sm transition-all"
            >
              <FaStethoscope className="h-4 w-4" />
              Doktor
            </TabsTrigger>
          </TabsList>

          <TabsContent value="patient" defaultValue="patient">
            <div className="flex flex-col space-y-5">
              <ContactPageForm
                label="İsim"
                placeHolder="İsminizi Giriniz."
                inputName="name"
                formDataValue={formData.name}
                gatherFormData={gatherFormData}
                formDataParam="name"
              />

              <ContactPageForm
                label="Telefon"
                placeHolder="Numaranızı Giriniz"
                inputName="phone"
                formDataValue={formData.phone}
                gatherFormData={gatherFormData}
                formDataParam="phone"
              />

              <ContactPageForm
                label="Email *"
                placeHolder="Email Adresinizi Giriniz"
                inputName="email"
                formDataValue={formData.email}
                gatherFormData={gatherFormData}
                formDataParam="email"
              />

              <div className="">
                <label className="text-sm font-medium text-gray-700">Mesaj</label>
                <textarea
                  name="message"
                  placeholder="Mesajınızı Giriniz"
                  value={formData.message}
                  rows={4}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                  required
                  onChange={(e) => gatherFormData("message", e)}
                />
              </div>
            </div>
          </TabsContent>
          <TabsContent value="doctor">
            <div className="flex flex-col space-y-5">
              <ContactPageForm
                label="İsim"
                placeHolder="İsminizi Giriniz."
                inputName="name"
                formDataValue={formData.name}
                gatherFormData={gatherFormData}
                formDataParam="name"
              />

              <ContactPageForm
                label="Kurumsal Telefon Numarası"
                placeHolder="Kurumsal Telefon Numaranızı Giriniz"
                inputName="phone"
                formDataValue={formData.phone}
                gatherFormData={gatherFormData}
                formDataParam="phone"
              />

              <ContactPageForm
                label="Kurumsal Email Adresi *"
                placeHolder="Kurumsal Email Adresinizi Giriniz"
                inputName="email"
                formDataValue={formData.email}
                gatherFormData={gatherFormData}
                formDataParam="email"
              />

              <div className="">
                <label className="text-sm font-medium text-gray-700">Mesaj</label>
                <textarea
                  name="message"
                  placeholder="Mesajınızı Giriniz"
                  value={formData.message}
                  rows={4}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                  required
                  onChange={(e) => gatherFormData("message", e)}
                />
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>

      <button disabled={isLoading} type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded-md transition cursor-pointer disabled:bg-blue-600/50">
        {isLoading ? "Gönderiliyor..." : "Gönder"}
      </button>
    </form>
  )
}
